'use client';

import Link from 'next/link';
import Cookies from 'js-cookie';
import { Button, Container, Divider, Group, Space, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { FullSizeLoader } from '@/src/components/Loader/FullSizeLoader';
import { TextCard } from '@/src/components/SliceMachine/TextCard/TextCard';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';
import { useAuthValidation } from '@/src/lib/hooks/useAuthValidation';

const Admin = () => {
  const dictionary = useDictionary();
  const mobile = useMediaQuery(`(max-width: 48em)`);

  const { isLoading } = useAuthValidation();

  if (isLoading) {
    return <FullSizeLoader />;
  }

  const handleLogout = () => {
    Cookies.remove('authToken');
    window.location.reload();
  };

  return (
    <Container>
      <Space h="xl" />
      <Container>
        <Button color="red" onClick={handleLogout}>
          {dictionary.header.logout}
        </Button>
      </Container>
      <Space h="xl" />
      <TextCard data={dictionary.pages.admin} />
      <Divider />
      <Space h="xl" />
      <Group justify="center">
        <Button component={Link} color="black" href="/admin/estimations">
          <img
            width="25"
            height="25"
            src="https://img.icons8.com/ios-filled/a8933c/25/search--v1.png"
            alt="search--v1"
            style={{ marginRight: '10px' }}
          />
          {dictionary.pages.admin.manageEstimations}
        </Button>
        <Button component={Link} color="black" href="/admin/products">
          <img
            width="25"
            height="25"
            src="https://img.icons8.com/ios-filled/a8933c/25/add--v1.png"
            alt="add--v1"
            style={{ marginRight: '10px' }}
          />
          {dictionary.pages.admin.addProducts}
        </Button>
        <Button component={Link} color="black" href="/admin/articles">
          <img
            width="25"
            height="25"
            src="https://img.icons8.com/ios-filled/a8933c/25/pencil--v1.png"
            alt="search--v1"
            style={{ marginRight: '10px' }}
          />
          {dictionary.pages.admin.addArticles}
        </Button>
      </Group>
      {mobile && (
        <Container>
          <Space h="lg" />
          <Text c="dimmed">
            La création d'articles n'est possible que depuis un ordinateur car l'éditeur de rich
            text ne supporte pas l'édition mobile
          </Text>
        </Container>
      )}
    </Container>
  );
};

export default Admin;
